import { Box, IconButton, Modal } from "@mui/material";
import { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
function ProductCommentPictureComponentV2({ photoModel }: any) {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const openPhotoInNewTab = (event: any) => {
    event.stopPropagation();
    window.open(photoModel.photoUrl, "_blank");
  };
  return (
    <>
      <Box
        position="relative"
        display="inline-block"
        width="100%"
        maxWidth={240}
        height={300}
        overflow="hidden"
        border="1px solid rgba(148, 163, 184, 0.22)"
        borderRadius="18px"
        sx={{
          cursor: "zoom-in",
          backgroundColor: "#fff",
          boxShadow: "0 18px 40px rgba(15, 23, 42, 0.14)",
          transition: "transform 0.2s ease, box-shadow 0.2s ease",
          "&:hover": {
            transform: "scale(1.02)",
            boxShadow: "0 22px 44px rgba(15, 23, 42, 0.18)",
          },
        }}
        onClick={handleOpen}
      >
        <img
          src={photoModel.photoUrl}
          alt="Zoomed"
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
        <IconButton
          onClick={(e: any) => openPhotoInNewTab(e)}
          sx={{
            position: "absolute",
            top: 10,
            right: 10,
            backgroundColor: "rgba(255, 255, 255, 0.92)",
            display: "block",
            boxShadow: "0 10px 20px rgba(15, 23, 42, 0.18)",
            "&:hover": {
              backgroundColor: "#fff",
            },
          }}
        >
          <Box sx={{ color: "#2563eb", display: "flex" }}>
            <OpenInNewIcon />
          </Box>
        </IconButton>
        <Box
          sx={{
            position: "absolute",
            left: 0,
            right: 0,
            bottom: 0,
            px: 1.5,
            py: 1,
            color: "#fff",
            fontSize: "0.9rem",
            fontWeight: 700,
            background: "linear-gradient(180deg, rgba(15,23,42,0) 0%, rgba(15,23,42,0.78) 100%)",
            textAlign: "left",
          }}
        >
          {photoModel.photoName}
        </Box>
      </Box>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "rgba(15, 23, 42, 0.92)",
            boxShadow: 24,
            p: 3,
            borderRadius: "24px",
            width: { xs: "92vw", md: "60vw", lg: "42vw" },
            maxHeight: "90vh",
            position: "relative",
          }}
        >
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 18,
              top: 18,
              color: "#fff",
              backgroundColor: "rgba(255,255,255,0.12)",
              "&:hover": {
                backgroundColor: "rgba(255,255,255,0.2)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
          <img
            width="100%"
            height="auto"
            src={photoModel.photoUrl}
            style={{
              maxWidth: "100%",
              maxHeight: "80vh",
              objectFit: "contain",
              borderRadius: "16px",
            }}
            alt="Zoomed"
          />
        </Box>
      </Modal>
    </>
  );
}
export default ProductCommentPictureComponentV2;
